module.exports = __webpack_public_path__ + "img/fail.57781f82.svg";